import { render, staticRenderFns } from "./GoogleUpdates.vue?vue&type=template&id=1e642fb5&scoped=true&"
import script from "./GoogleUpdates.vue?vue&type=script&lang=js&"
export * from "./GoogleUpdates.vue?vue&type=script&lang=js&"
import style0 from "./GoogleUpdates.vue?vue&type=style&index=0&id=1e642fb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e642fb5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VContainer,VFadeTransition,VIcon,VProgressCircular})
